<template>
    <div class="bgFrame">
        <div class="box" style="z-index:500;">
            <img src="../../assets/home_banner1.png" class="bgImg" />
        </div>
        <div class="boxs" :style="'background-image: url(' + pointImg + ');'">
        </div>
        <div class="box" style="z-index:502;height: auto;overflow: visible;align-items: center;justify-content: flex-start;">
            <div class="textFrame">
                <div :class="topMessageClass">
                  <div style="margin-top:225px;"></div>
                    <div class="textTitle">營和味，</div>
                    <img src="../../assets/home_text_eng1.png" class="textImg" />
                    <div class="textTitle">永遠「型」合你口味</div>
                </div>
                <div style="width:100%;padding-top: 62px;"></div>
                <div :class="bottomMessageClass">
                    <p style="color:#243C05;">NuMatch，為Nutrition Matching含意的自創詞<br>營和味，有營養&味道的含義，「和」亦有組合之意</p><br><br><p style="color:#E4ECD9;">這是一個由一群崇尚健康飲食的年青人所打造的智能健康餐飲品牌，提供創意健康食品，為追求健康生活態度的消費者提供健康飲食新選擇。<br> 透過創意健康餐的自由組合及智能化營養推薦，高度匹配定制化健康需求及營養需要，為你量身訂做個性化健康餐飲，打造健康飲食新生活，滿足你低卡健康與營養美味並重的餐飲需求。</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {ref, onMounted } from "vue";

export default {
  name: 'App',
  components: {
  },
  setup() {
    onMounted(() => {
    });
    let mainImgClass = ref('start_mainImg')
    let topMessageClass = ref('start_textSubFrame')
    let bottomMessageClass = ref('start_textContent')

    const startAnime = ref(false)
    const changeAnime = () =>{
        mainImgClass.value = 'start_mainImg'
        topMessageClass.value = 'start_textSubFrame'
        bottomMessageClass.value = 'start_textContent'

        if (startAnime.value == false) {
            setTimeout(() => {
                mainImgClass.value = 'mainImg'
                topMessageClass.value = 'textSubFrame'
                setTimeout(() => {
                    bottomMessageClass.value = 'textContent'
                }, 400);
            }, 100);
        }
    }
    let pointImg = ref(require('../../assets/noise.png'))
    return {
      pointImg,
        mainImgClass,
        topMessageClass,
        bottomMessageClass,
        startAnime,
        changeAnime
    };
  },
}
</script>

<style lang="less" scoped>
.bgFrame{
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.box{
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.bgImg{
  height: 100%;
  min-height: 878px;
  position: absolute;
  top: 0;
  object-fit: cover;
}
@keyframes mainImgAnime {
  from {
      transform: translate(200px, 0px);
      opacity: 0;
  }
  to {
      transform: translate(0px, 0px);
      opacity: 1;
  }
}
.mainImg{
    width: calc(100% / 1080 * 450);
    height: 450 / 518;
    margin-left: calc(100% / 1080 * 574);
    opacity: 1;
    animation-name: mainImgAnime;
    animation-duration: 2s;
}
.start_mainImg{
    width: calc(100% / 1080 * 450);
    height: 450 / 518;
    margin-left: calc(100% / 1080 * 574); 
    opacity: 0;
}
.textFrame{
    height: 100%;
    margin-left: calc((100% - 1100px) / 2);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
}
@keyframes textSubAnime {
  from {
      transform: translate(0px, -60px);
      opacity: 0;
  }
  to {
      transform: translate(0px, 0px);
      opacity: 1;
  }
}

.textSubFrame{
    opacity: 1;
    display: flex;
    flex-direction: column;
    justify-content: left;
    animation-name: textSubAnime;
    animation-duration: 1s;
}

.start_textSubFrame{
    opacity: 0;
    display: flex;
    flex-direction: column;
    justify-content: left;
}

.textTitle{
    font-size: 65px;
    color: #658343;
    text-align: left;
}
.textImg{
    width: 548px;   
}

@keyframes textContentAnime {
  from {
      transform: translate(0px, 60px);
      opacity: 0;
  }
  to {
      transform: translate(0px, 0px);
      opacity: 1;
  }
}

.textContent{
  width: 613px;
    opacity: 1;
    text-align: left;
    font-size: 16px;
    line-height: 29px;
    font-family: MicrosoftYaHeiLight;
    color: white;
    animation-name: textContentAnime;
    animation-duration: 1s;
}

.start_textContent{
    opacity: 0;
    width: 613px;
    text-align: left;
    font-size: 16px;
    font-family: MicrosoftYaHeiLight;
    color: white;
    line-height: 29px;
}

@keyframes pointAnime{
  0% {
    transform: translate3d(0,9px,0)
  }
  10% {
    transform: translate3d(-1px,-4px,0)
  }
  20% {
    transform: translate3d(-8px,2px,0)
  }
  30% {
    transform: translate3d(-9px,-9px,0)
  }
  40% {
    transform: translate3d(2px,7px,0)
  }
  50% {
    transform: translate3d(9px,-4px,0)
  }
  60% {
    transform: translate3d(2px,6px,0)
  }
  70% {
    transform: translate3d(7px,-8px,0)
  }
  80% {
    transform: translate3d(-9px,1px,0)
  }
  90% {
    transform: translate3d(6px,-5px,0)
  }
  to {
    transform: translate3d(-7px,0,0)
  }
}
.boxs {
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 501;
  position: absolute;
  background-position:50%;
  animation :pointAnime 1.3s steps(2) infinite;
}

</style>
